export default function ownerDocument(_0x4a1b8b){return _0x4a1b8b&&_0x4a1b8b['ownerDocument']||document;}